<template>
    <div class="my-offices">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 locations">
                    <div class="row details">
                        <div class="col-12">
                            <img src="../../assets/images/couch.png" height="75px" width="75px" class="mx-auto d-block">
                            <p><strong>Nicholson House</strong></p>
                            <br>

                            <p>41 Thames Street</p>
                            <p>Weybridge</p>
                            <p>Surrey KT13 8JG</p>
                        </div>
                        <div class="col-12 times">
                            <p>MONDAY</p>
                        </div>
                    </div>
                </div>
                <hr align="center" class="divider">
                <div class="col-lg-4 locations">
                    <div class="row details">
                        <div class="col-12">
                            <img src="../../assets/images/couch.png" height="75px" width="75px" class="mx-auto d-block">
                            <p><strong>Nuffield Health Hospital</strong></p>
                            <p class="inline-responsive">Shores Road</p>
                            <p>Woking</p>
                            <p>Surrey GU21 4BY</p>
                        </div>
                        <div class="col-12 times">
                          <p>TUESDAY (AM)</p>
                        </div>
                        <div class="col-12 office-link">
                            <a href="https://www.nuffieldhealth.com/hospitals/woking" target="_blank">Click here to view</a>
                        </div>
                    </div>
                </div>
                <hr align="center" class="divider">
                <div class="col-lg-4 locations">
                    <div class="row details">
                        <div class="col-12">
                            <img src="../../assets/images/couch.png" height="75px" width="75px" class="mx-auto d-block">
                            <p><strong>Princess Margaret Hospital</strong></p>
                            <p class="inline-responsive">Osborne Road</p>
                            <p>Windsor</p>
                            <p>Berkshire SL4 3SJ</p>
                        </div>
                        <div class="col-12 times">
                            <p>WEDNESDAY</p>
                        </div>
                        <div class="col-12 office-link">
                            <a href="https://www.bmihealthcare.co.uk/hospitals/bmi-the-princess-margaret-hospital" target="_blank">Click here to view</a>
                        </div>
                    </div>
                </div>
                <hr align="center" class="divider">
                <div class="offset-lg-4 col-lg-4 appointment">
                        <p>Contact Julie Cook, Practice Manager</p>
                        <p><a href="tel:01276857090" onclick="gtag('event', 'Number', { 'event_category': 'Phone', 'event_label': 'Clicked' });">01276 857090</a></p>
                        <p>To Make An Appointment</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MyOffices'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/MyOffices.vue